import { useState, useEffect, useMemo } from 'react';
import AuthService from '@/services/AuthService';

export function useAuth() {
  const authService = AuthService.getInstance();
  const [state, setState] = useState(authService.getState());

  useEffect(() => {
    const unsubscribe = authService.subscribe(setState);
    return unsubscribe;
  }, [authService]);

  const actions = useMemo(() => ({
    signIn: authService.signIn.bind(authService),
    signUp: authService.signUp.bind(authService),
    signOut: authService.signOut.bind(authService),
    updatePassword: authService.updatePassword.bind(authService),
    resetPassword: authService.resetPassword.bind(authService),
    hasAdminAccess: authService.hasAdminAccess.bind(authService),
    isApproved: authService.isApproved.bind(authService),
    isPending: authService.isPending.bind(authService),
    refreshProfile: authService.refreshProfile.bind(authService),
    getDefaultRoute: authService.getDefaultRoute.bind(authService),
  }), [authService]);

  return {
    // State
    user: state.user,
    session: state.session,
    profile: state.profile,
    profileLoading: state.profileLoading,
    loading: state.loading,
    error: state.error,

    ...actions,
  };
}
